module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fullscreenLoading),
      expression: "fullscreenLoading"
    }],
    attrs: {
      "element-loading-text": "正在绑定授权信息"
    }
  })
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-779f1631", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-779f1631"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/authloading.vue
// module id = 2838
// module chunks = 0